// admin-analytics-expansion P2b — Ticket Browse route
//
// Access: org_admin + supervisor (mirrors ticket-analytics R4). super_admin /
// operator → denied message. Server is the real authority (assertLocationScope
// + supervisor auto-scope enforced per-request in browse-tickets.use-case.ts);
// this is a UX gate only, mirroring the analytics/audit-log route convention.
//
// NOTE: .index.tsx suffix REQUIRED (same convention as audit-log/analytics routes).

import { useTranslation } from '@jq4race/i18n';
import { createFileRoute } from '@tanstack/react-router';
import { ShieldOff } from 'lucide-react';

import { getCurrentSession } from '../app/auth-state';
import { PageHeader } from '../modules/app-shell/ui/PageHeader';
import { TicketBrowsePage } from '../modules/tickets/ui/pages/TicketBrowsePage';

const ALLOWED_ROLES = ['org_admin', 'supervisor'];

function TicketBrowseRouteComponent() {
  const session = getCurrentSession();
  const role = session?.user.role ?? '';

  if (!ALLOWED_ROLES.includes(role)) {
    return <DeniedPage />;
  }

  return <TicketBrowsePage />;
}

function DeniedPage() {
  const { t } = useTranslation('tickets');
  return (
    <div className="space-y-8">
      <PageHeader eyebrow={t('page.eyebrow')} title={t('page.browseTitle')} />
      <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
        <ShieldOff className="h-10 w-10 text-jq-stone" strokeWidth={1.25} />
        <p className="text-[14px] font-medium text-jq-charcoal">{t('page.permissionDenied')}</p>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/dashboard/tickets/')({
  component: TicketBrowseRouteComponent,
  staticData: {
    breadcrumb: ['Tickets', 'Ticket Browse'],
  },
});
